import { Box, Paper, Stack, Typography } from "@mui/material";
import type { ReactNode } from "react";
import { LabellingCoverageBucket } from "store/api/generatedApi";
import { CoverageStackedChart } from "./CoverageStackedChart";
import { CoverageSummary } from "./CoverageSummary";

interface CoverageSectionProps {
  title: string;
  buckets: LabellingCoverageBucket[];
  summary: LabellingCoverageBucket;
  headerAction?: ReactNode;
}

export const CoverageSection = ({
  title,
  buckets,
  summary,
  headerAction,
}: CoverageSectionProps) => {
  return (
    <Paper sx={{ p: 3 }}>
      <Stack spacing={2}>
        <Stack direction="row" spacing={2} alignItems="center">
          <Typography variant="h6" sx={{ flex: 1 }}>
            {title}
          </Typography>
          {headerAction}
        </Stack>

        <Box sx={{ height: 300 }}>
          <CoverageStackedChart
            buckets={buckets}
            height={300}
            showLegend
            showXAxis
            showYAxis
          />
        </Box>

        <CoverageSummary
          labellableFraction={summary.labellable_fraction}
          verifiedFraction={summary.verified_fraction}
          labelledByPasses={summary.labelled_by_passes}
        />
      </Stack>
    </Paper>
  );
};
